const defaultAllowedProtocols = new Set(["https:", "http:"])

export const safeExternalUrl = (
  value?: string | null,
  options: {
    allowedProtocols?: Set<string>
    allowedHostSuffixes?: string[]
  } = {},
) => {
  if (!value) return undefined
  try {
    const url = new URL(value)
    const protocols = options.allowedProtocols || defaultAllowedProtocols
    if (!protocols.has(url.protocol)) return undefined
    if (options.allowedHostSuffixes?.length) {
      const hostname = url.hostname.toLowerCase()
      const allowed = options.allowedHostSuffixes.some((suffix) => {
        const normalized = suffix.toLowerCase()
        return hostname === normalized || hostname.endsWith(`.${normalized}`)
      })
      if (!allowed) return undefined
    }
    return url.toString()
  } catch {
    return undefined
  }
}

export const safeLinkedInUrl = (value?: string | null) =>
  safeExternalUrl(value, { allowedHostSuffixes: ["linkedin.com"] })
